import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminComponent } from './submodules/admin/pages/admin/admin.component';
import { ErrorPageComponent } from './pages/error-page/error-page.component';
import { AccessDeniedComponent } from './pages/access-denied/access-denied.component';
import { authGuard } from './guards/auth.guard';
import { HomeDashboardComponent } from './pages/home-dashboard/home-dashboard.component';

const routes: Routes = [
  { path: '', component: HomeDashboardComponent, canActivate: [authGuard] },
  { path: 'home', redirectTo: '/', pathMatch: 'full' },
  {
    path: 'expansion',
    loadChildren: () =>
      import(
        './submodules/fertility-dashboard/fertility-dashboard.module'
      ).then((m) => m.FertilityDashboardModule),
    canActivate: [authGuard],
  },
  {
    path: 'specs',
    loadChildren: () =>
      import('./submodules/mecs-dashboard/mecs-dashboard.module').then(
        (m) => m.MecsDashboardModule
      ),
    canActivate: [authGuard],
  },
  {
    path: 'admin',
    component: AdminComponent,
    loadChildren: () =>
      import('./submodules/admin/admin.module').then((m) => m.AdminModule),
  },
  { path: 'access-denied', component: AccessDeniedComponent },
  { path: '**', component: ErrorPageComponent, canActivate: [authGuard] },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
